import styles from './EditSubDomainControlDialog.module.scss'
import { mailBody } from './mailContent'

const CNAMEInstructions = () => {
  const steps = [
    {
      title: "Log in to Your Domain Provider's Website:",
      items: [
        'Go to the website of the company where you registered your domain.',
        'Log in to your account using your credentials.'
      ]
    },
    {
      title: 'Navigate to DNS Settings or Domain Management:',
      items: [
        'Find the DNS management or domain management section. It may be labeled as "DNS Settings," "Domain Management," "Name Server Management," or something similar.'
      ]
    },
    {
      title: 'Locate the CNAME Option:',
      items: [
        'Look for an option to add or edit DNS records.',
        'Find the section related to CNAME records.'
      ]
    },
    {
      title: 'Add a New CNAME Record:',
      items: [
        "In the CNAME record section, you'll typically see fields for the hostname, type, and value.",
        'Enter the desired subdomain or alias in the "Hostname" or "Alias" field. This is the part of the domain that will be associated with the CNAME record.',
        'Set the type to "CNAME" (this might be a dropdown or radio button selection).',
        'Enter "savibook.com" to the value.',
        'Save or Update the Changes'
      ]
    }
  ]

  const generateMailtoLink = () => {
    const subject = encodeURIComponent('Domain configuration instructions for Directful')
    const body = mailBody

    return `mailto:?subject=${subject}&body=${body}`
  }

  return (
    <div className={styles.cnameInstructions}>
      <h1>Adding a CNAME (Canonical Name) record to your domain</h1>
      <p className={styles.intro}>
        Adding a CNAME (Canonical Name) record to your domain involves accessing your
        domain provider's DNS (Domain Name System) settings and making the necessary
        changes. The specific steps can vary depending on your domain registrar, but the
        general process is similar.
      </p>
      <div className={styles.links}>
        <a
          href="https://www.godaddy.com/help/edit-a-cname-record-19237"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn how to add a CNAME record on Godaddy
        </a>
        <a
          href="https://www.namecheap.com/support/knowledgebase/article.aspx/9646/2237/how-to-create-a-cname-record-for-your-domain/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn how to add a CNAME record on Namecheap
        </a>
      </div>
      <ol className={styles.steps}>
        {steps.map((step, index) => (
          <li key={index}>
            <h2>{step.title}</h2>
            <ul>
              {step.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
      <div className={styles.footer}>
        <a href={generateMailtoLink()} target="_blank" rel="noopener noreferrer">
          Share this with your IT professional
        </a>
      </div>
    </div>
  )
}

export default CNAMEInstructions
